/* STACK'D Demo 1 — cart drawer, theme toggle, catalog filters, bulk order, product page. */
(function () {
  var CFG = window.SD1 || { moq: 150, cartUrl: '/cart' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Currency: follows the buyer's selected Shopify Markets currency */
  /* Currency follows the buyer's country (Shopify Markets). Amounts from Shopify are already converted; RATE converts fixed store-currency values like the MOQ. */
  var CUR = CFG.usd ? 'USD' : ((window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'USD');
  var RATE = CFG.usd ? 1 : (parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1);
  var fmt; try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR, currencyDisplay: 'narrowSymbol' }); } catch (e) { try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR }); } catch (e2) { fmt = null; } }
  /* Display-only currency (Always-USD mode): prices are shown as estimates, checkout stays USD */
  var COUNTRY_CUR = { US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', NZ: 'NZD', AE: 'AED', SA: 'SAR', PK: 'PKR', IN: 'INR', ZA: 'ZAR', SG: 'SGD',
    IE: 'EUR', DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR', PT: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', MT: 'EUR', CY: 'EUR', HR: 'EUR' };
  var DISP = 'USD', DRATE = 1, dfmt = null;
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function usdOut(cents) { var n = (cents || 0) / 100; return fmt ? fmt.format(n) : CUR + ' ' + n.toFixed(2); }
    function fitText() { $$('[data-fit]').forEach(function (el) { el.style.fontSize = ''; var fs = parseFloat(getComputedStyle(el).fontSize); while (el.scrollWidth > el.clientWidth && fs > 12) { fs -= 1; el.style.fontSize = fs + 'px'; } }); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);
  window.addEventListener('resize', fitText);
  function money(cents) {
    if (CFG.usd && DISP !== 'USD' && dfmt) return dfmt.format((cents || 0) / 100 * DRATE);
    return usdOut(cents);
  }
  function moneyShort(cents) { return money(cents).replace(/[.,]00(?!\d)/, ''); }
  var MOQ = (CFG.moq || 150) * RATE; /* minimum order converted into the active currency */
  function paintPrices() {
    $$('[data-money-shop]').forEach(function (el) { el.textContent = moneyShort(Math.round(parseInt(el.getAttribute('data-money-shop'), 10) * RATE)); });
    $$('[data-usd]').forEach(function (el) { if (el.closest('[data-money-shop]')) return; var c = Math.round(parseFloat(el.getAttribute('data-usd')) || 0); el.textContent = el.hasAttribute('data-short') ? moneyShort(c) : money(c); });
        $$('[data-price-label]').forEach(function (o) { var m = function (c) { return moneyShort(c); }, p = o.getAttribute('data-price-label').split(':'); o.textContent = (p[0] === 'under' ? 'Under ' + m(+p[1]) : p[0] === 'over' ? m(+p[1]) + ' and up' : m(+p[1]) + ' to ' + m(+p[2])); });
    $$('[data-disp-cur]').forEach(function (s) { s.value = DISP; });
    $$('[data-paynote]').forEach(function (n) { n.hidden = !(CFG.usd && DISP !== 'USD'); n.innerHTML = 'Prices in ' + DISP + ' are estimates. You pay in USD at checkout. <a href="https://www.exchangerate-api.com" target="_blank" rel="noopener">Rates by ExchangeRate-API</a>'; });
        fitText();
    document.dispatchEvent(new CustomEvent('sd1:currency'));
  }
  function setDisplay(code, rates) {
    if (!rates || !rates[code]) code = 'USD';
    DISP = code; DRATE = code === 'USD' ? 1 : rates[code];
       try { dfmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: code }); } catch (e) { dfmt = null; }
    paintPrices();
  }
  function loadRates(cb) {
    var cached = null; try { cached = JSON.parse(lsGet('sd1-rates') || 'null'); } catch (e) {}
    if (cached && cached.t > Date.now() - 12 * 3600e3) return cb(cached.r);
    fetch('https://open.er-api.com/v6/latest/USD').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.rates) { lsSet('sd1-rates', JSON.stringify({ t: Date.now(), r: d.rates })); cb(d.rates); } else cb(cached && cached.r);
    }).catch(function () { cb(cached && cached.r); });
  }
  paintPrices();
  if (CFG.usd) {
    var want = lsGet('sd1-cur') || COUNTRY_CUR[CFG.country] || 'USD';
    var RATES = null;
    if (want !== 'USD') loadRates(function (r) { RATES = r; setDisplay(want, r); });
    document.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-disp-cur]'); if (!s) return;
      lsSet('sd1-cur', s.value);
      if (s.value === 'USD') return setDisplay('USD', { USD: 1 });
      if (RATES) setDisplay(s.value, RATES); else loadRates(function (r) { RATES = r; setDisplay(s.value, r); });
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.style.display = 'block';
    clearTimeout(t._h); t._h = setTimeout(function () { t.style.display = 'none'; }, 2600);
  }

  /* ---------- Theme toggle ---------- */
  function syncThemeBtn() {
    var dark = document.documentElement.getAttribute('data-theme') === 'dark';
    $$('[data-theme-toggle]').forEach(function (b) { b.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode'); b.setAttribute('aria-pressed', dark ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-theme-toggle]'); if (!b) return;
    var dark = document.documentElement.getAttribute('data-theme') !== 'dark';
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    try { localStorage.setItem('sd1-theme', dark ? 'dark' : 'light'); } catch (er) {}
    syncThemeBtn();
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#sd1-drawer');
  var lastCart = null;
  document.addEventListener('sd1:currency', function () { if (lastCart) renderCart(lastCart); });
  function renderCart(cart) {
    lastCart = cart;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var box = $('[data-cart-items]', drawer);
    if (!cart.item_count) {
      box.innerHTML = '<p>Your wholesale cart is empty.</p><a class="sd1-btn sd1-btn--solid" href="' + esc(CFG.catalogUrl || '/collections/all') + '">Browse lots</a>';
    } else {
      box.innerHTML = cart.items.map(function (it) {
        var step = Math.max(1, Math.round(it.quantity / 5) || 5);
        var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="">' : '';
        return '<div class="sd1-ci">' + img + '<div class="sd1-ci__body">' +
          '<div class="sd1-ci__top"><a href="' + esc(it.url) + '" style="font-weight:700;text-decoration:none">' + esc(it.product_title) + '</a>' +
          '<button type="button" class="sd1-link" data-cart-change="' + esc(it.key) + '" data-q="0" aria-label="Remove ' + esc(it.product_title) + '">Remove</button></div>' +
          (it.variant_title ? '<span style="color:var(--muted)">' + esc(it.variant_title) + '</span>' : '') +
          '<div class="sd1-ci__top"><span class="sd1-step-q"><button type="button" data-cart-change="' + esc(it.key) + '" data-q="' + Math.max(0, it.quantity - step) + '" aria-label="Fewer">−</button><span>' + it.quantity + '</span><button type="button" data-cart-change="' + esc(it.key) + '" data-q="' + (it.quantity + step) + '" aria-label="More">+</button></span>' +
          '<span>' + money(it.final_price) + ' / pc<br><b>' + money(it.final_line_price) + '</b></span></div></div></div>';
      }).join('');
    }
    var total = cart.total_price / 100;
    $('[data-cart-units]', drawer).textContent = cart.item_count + ' pcs';
    $('[data-cart-subtotal]', drawer).textContent = (CFG.usd && DISP !== 'USD') ? money(cart.total_price) + ' (' + usdOut(cart.total_price) + ')' : money(cart.total_price) + ' ' + CUR;
    $('[data-moq-text]', drawer).textContent = money(cart.total_price) + ' / ' + moneyShort(Math.round(MOQ * 100));
    $('[data-moq-bar]', drawer).style.width = Math.min(100, Math.round(total / MOQ * 100)) + '%';
    var ok = total >= MOQ - 0.005;
    $('[data-moq-hint]', drawer).textContent = ok ? 'Minimum order met. You can check out.' : 'Add ' + money(Math.round((MOQ - total) * 100)) + ' more to check out.';
    $('[data-checkout]', drawer).disabled = !ok;
  }
  function refreshCart() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(renderCart); }
  function openCart() {
    if (!drawer) { location.href = CFG.cartUrl; return; }
    drawer.removeAttribute('inert'); drawer.classList.add('is-open'); drawer._ret = document.activeElement;
    document.body.style.overflow = 'hidden';
    refreshCart(); setTimeout(function () { var c = $('[data-cart-close]', drawer); if (c) c.focus(); }, 50);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('inert', ''); document.body.style.overflow = ''; if (drawer._ret && drawer._ret.focus) drawer._ret.focus();
  }
  window.sd1OpenCart = openCart;
  function addItems(items, btn) {
    if (btn) { btn.disabled = true; btn._t = btn.textContent; btn.textContent = 'Adding...'; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(function () { openCart(); })
      .catch(function (err) { toast(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn._t; } });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]'); if (o) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === drawer) { closeCart(); return; }
    var ch = e.target.closest('[data-cart-change]');
    if (ch) {
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ch.getAttribute('data-cart-change'), quantity: parseInt(ch.getAttribute('data-q'), 10) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
    var add = e.target.closest('[data-add]');
    if (add) { addItems([{ id: parseInt(add.getAttribute('data-add'), 10), quantity: parseInt(add.getAttribute('data-qty'), 10) || 1 }], add); return; }
    var ck = e.target.closest('[data-checkout]');
    if (ck) {
      ck.disabled = true; ck.textContent = 'Opening checkout...';
      location.href = root + 'checkout';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  /* Cart page: minimum order check in the buyer's currency */
  (function () {
    var w = $('[data-cp-moq]'); if (!w) return;
    var total = parseInt(w.getAttribute('data-total'), 10) || 0, moqC = Math.round(MOQ * 100), ok = total >= moqC - 1;
    var fill = $('[data-cp-fill]'), hint = $('[data-cp-hint]'), btn = $('[data-cp-btn]'), lab = $('[data-cp-label]');
    if (fill) fill.style.width = Math.min(100, Math.round(total / moqC * 100)) + '%';
    if (hint) { hint.textContent = ok ? 'Minimum order met!' : 'Add ' + money(moqC - total) + ' more to unlock checkout'; hint.classList.toggle('ok', ok); }
    if (btn) btn.disabled = !ok; if (lab) lab.textContent = ok ? 'Proceed to B2B Checkout' : 'Minimum Order Not Met';
  })();
  /* Full cart page (existing section) uses this name */
  window.cartPageCheckout = function () {
    var po = ($('#po-input') || {}).value || '';
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: po ? 'PO Number: ' + po : '' }) })
      .finally(function () { location.href = root + 'checkout'; });
  };

  /* ---------- Catalog ---------- */
  function initCatalog() {
    var wrap = $('[data-catalog]'); if (!wrap) return;
    var pageSize = parseInt(wrap.getAttribute('data-page-size'), 10) || 12;
    var params = new URLSearchParams(location.search);
    var state = { cat: params.get('cat') || '', brand: params.get('brand') || '', grade: params.get('grade') || '', price: '', sort: '', q: (params.get('q') || '').trim().toLowerCase(), shown: pageSize };
    var cards = $$('[data-lot]', $('[data-grid]', wrap));
    var rows = $$('[data-row]', wrap);
    var grid = $('[data-grid]', wrap);
    var sel = function (k) { return $('[data-filter="' + k + '"]', wrap); };
    var qs = $$('[data-search-input]'); qs.forEach(function (i) { if (state.q) i.value = params.get('q'); });
    if (state.brand && sel('brand')) {
      var match = $$('option', sel('brand')).filter(function (o) { return o.value.toLowerCase() === state.brand.toLowerCase(); })[0];
      if (match) { sel('brand').value = match.value; state.brand = match.value; }
    }
    if (state.grade && sel('grade')) sel('grade').value = state.grade;

    function passes(el) {
      var d = el.dataset;
      if (state.cat && d.cat !== state.cat) return false;
      if (state.brand && d.brand !== state.brand) return false;
      if (state.grade && d.grade !== state.grade) return false;
      if (state.price) { var pr = state.price.split('-'), p = parseFloat(d.price); if (p < +pr[0] * RATE || p >= +pr[1] * RATE) return false; }
      if (state.q && (d.search || '').indexOf(state.q) === -1) return false;
      return true;
    }
    function order(list) {
      var s = state.sort;
      return list.slice().sort(function (a, b) {
        if (s === 'price-asc') return a.dataset.price - b.dataset.price;
        if (s === 'price-desc') return b.dataset.price - a.dataset.price;
        if (s === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        return a.dataset.index - b.dataset.index;
      });
    }
    function chip(label, key) { return '<span class="sd1-pill sd1-pill--lilac">' + esc(label) + ' <button type="button" aria-label="Remove ' + esc(label) + '" data-unset="' + key + '" style="background:none;color:inherit;font-weight:900;cursor:pointer">×</button></span>'; }
    function apply() {
      var ok = order(cards.filter(passes));
      cards.forEach(function (c) { c.hidden = true; });
      ok.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= state.shown; });
      var okRows = order(rows.filter(passes)), tb = rows.length ? rows[0].parentNode : null;
      rows.forEach(function (r) { r.hidden = true; });
      okRows.forEach(function (r) { if (tb) tb.appendChild(r); r.hidden = false; });
      $('[data-count]', wrap).textContent = ok.length;
      $('[data-empty]', wrap).hidden = ok.length > 0;
      var more = $('[data-more]', wrap); more.hidden = ok.length <= state.shown;
      more.textContent = 'Show more lots (' + Math.max(0, ok.length - state.shown) + ' more)';
      $$('[data-cat-chip]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cat-chip') === state.cat ? 'true' : 'false'); });
      var act = [];
      if (state.cat) act.push(chip(state.cat, 'cat'));
      if (state.brand) act.push(chip(state.brand, 'brand'));
      if (state.grade) act.push(chip('Grade ' + state.grade, 'grade'));
      if (state.price) act.push(chip(sel('price').selectedOptions[0].textContent, 'price'));
      if (state.q) act.push(chip('"' + state.q + '"', 'q'));
      $('[data-active-chips]', wrap).innerHTML = act.join(' ');
      $$('[data-clear]', wrap).forEach(function (b) { if (b.closest('.sd1-active')) b.hidden = act.length === 0; });
      var u = new URL(location.href);
      ['cat', 'brand', 'grade', 'q'].forEach(function (k) { if (state[k]) u.searchParams.set(k, state[k]); else u.searchParams.delete(k); });
      history.replaceState(null, '', u);
      bulkTotals();
    }
    wrap.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cat-chip]'); if (c) { state.cat = c.getAttribute('data-cat-chip'); state.shown = pageSize; apply(); return; }
      var un = e.target.closest('[data-unset]'); if (un) { var k = un.getAttribute('data-unset'); state[k] = ''; if (sel(k)) sel(k).value = ''; if (k === 'q') qs.forEach(function (i) { i.value = ''; }); apply(); return; }
      if (e.target.closest('[data-clear]')) { state.cat = state.brand = state.grade = state.price = state.q = ''; ['grade', 'brand', 'price'].forEach(function (k) { sel(k).value = ''; }); qs.forEach(function (i) { i.value = ''; }); state.shown = pageSize; apply(); return; }
      if (e.target.closest('[data-more]')) { state.shown += pageSize; apply(); return; }
      var v = e.target.closest('[data-view]'); if (v) setView(v.getAttribute('data-view'));
    });
    $$('[data-filter]', wrap).forEach(function (s) { s.addEventListener('change', function () { state[s.getAttribute('data-filter')] = s.value; state.shown = pageSize; apply(); }); });
    qs.forEach(function (q) {
      var form = q.closest('form');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); state.q = q.value.trim().toLowerCase(); apply(); });
      q.addEventListener('input', function () { state.q = q.value.trim().toLowerCase(); qs.forEach(function (o) { if (o !== q) o.value = q.value; }); state.shown = pageSize; apply(); });
    });
    function setView(view) {
      $$('[data-view]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false'); });
      $('[data-grid-view]', wrap).hidden = view === 'bulk';
      $('[data-bulk-view]', wrap).hidden = view !== 'bulk';
      var u = new URL(location.href); if (view === 'bulk') u.searchParams.set('view', 'bulk'); else u.searchParams.delete('view'); history.replaceState(null, '', u);
    }
    /* Bulk sheet */
    function bulkTotals() {
      var n = 0, pcs = 0, cents = 0;
      rows.forEach(function (r) {
        var qi = $('[data-bulk-qty]', r); if (!qi) return;
        var line = (parseInt(qi.value, 10) || 0) * parseInt(qi.getAttribute('data-price-cents'), 10);
        $('[data-line]', r).textContent = money(line);
        var cb = $('[data-bulk-check]', r);
        if (cb && cb.checked && !r.hidden) { n++; pcs += parseInt(qi.value, 10) || 0; cents += line; }
      });
      var set = function (s, v) { var el = $(s, wrap); if (el) el.textContent = v; };
      set('[data-bulk-n]', n); set('[data-bulk-pcs]', pcs); set('[data-bulk-total]', money(cents));
      var b = $('[data-bulk-add]', wrap); if (b) b.disabled = n === 0;
    }
    document.addEventListener('sd1:currency', bulkTotals);
    wrap.addEventListener('input', function (e) { if (e.target.matches('[data-bulk-qty]')) bulkTotals(); });
    wrap.addEventListener('change', function (e) {
      if (e.target.matches('[data-bulk-all]')) rows.forEach(function (r) { var cb = $('[data-bulk-check]', r); if (cb && !r.hidden) cb.checked = e.target.checked; });
      if (e.target.matches('[data-bulk-qty]')) { var mn = parseInt(e.target.min, 10) || 1; if ((parseInt(e.target.value, 10) || 0) < mn) e.target.value = mn; }
      bulkTotals();
    });
    var bulkAdd = $('[data-bulk-add]', wrap);
    if (bulkAdd) bulkAdd.addEventListener('click', function () {
      var items = rows.filter(function (r) { var cb = $('[data-bulk-check]', r); return cb && cb.checked && !r.hidden; }).map(function (r) {
        return { id: parseInt($('[data-bulk-check]', r).value, 10), quantity: parseInt($('[data-bulk-qty]', r).value, 10) || 1 };
      });
      if (items.length) addItems(items, bulkAdd).then(function () { $$('[data-bulk-check]', wrap).forEach(function (c) { c.checked = false; }); var all = $('[data-bulk-all]', wrap); if (all) all.checked = false; bulkTotals(); });
    });
    if (params.get('view') === 'bulk') setView('bulk');
    apply();
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var moq = parseInt(pdp.getAttribute('data-moq'), 10) || 1;
    var qty = moq;
    var vEl = $('[data-variant]', pdp);
    function unitCents() {
      if (!vEl) return 0;
      var opt = vEl.tagName === 'SELECT' ? vEl.selectedOptions[0] : vEl;
      return parseInt(opt.getAttribute('data-price'), 10) || 0;
    }
    function update() {
      $('[data-unit-price]', pdp).textContent = money(unitCents());
      $('[data-lot-total]', pdp).textContent = money(unitCents() * qty) + ' for ' + qty + ' pcs';
    }
    document.addEventListener('sd1:currency', update);
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) { qty = parseInt(b.getAttribute('data-q'), 10); $$('[data-q]', pdp).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); var c = $('[data-q-custom]', pdp); if (c) c.value = ''; update(); return; }
      var a = e.target.closest('[data-pdp-add]');
      if (a) addItems([{ id: parseInt(vEl.value, 10), quantity: qty }], a);
      var m = e.target.closest('[data-media]');
      if (m) {
        var tpl = $('[data-media-tpl="' + m.getAttribute('data-media') + '"]', pdp), stage = $('[data-stage]', pdp);
        if (tpl && stage) { stage.innerHTML = tpl.innerHTML; $$('[data-media]', pdp).forEach(function (x) { x.setAttribute('aria-current', x === m ? 'true' : 'false'); }); }
      }
    });
    var custom = $('[data-q-custom]', pdp);
    if (custom) custom.addEventListener('input', function () {
      var v = parseInt(custom.value, 10);
      if (v >= moq) { qty = v; $$('[data-q]', pdp).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); update(); }
    });
    if (custom) custom.addEventListener('change', function () { if ((parseInt(custom.value, 10) || 0) < moq) { custom.value = moq; qty = moq; update(); } });
    if (vEl && vEl.tagName === 'SELECT') vEl.addEventListener('change', update);
    update();
  }

  /* ---------- Tabs (arrow-key accessible) ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (t) {
      var tabs = $$('[role=tab]', t);
      function select(tab) {
        tabs.forEach(function (x) { var on = x === tab; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; $('#' + x.getAttribute('aria-controls')).hidden = !on; });
        tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') select(tabs[(i + 1) % tabs.length]);
          if (e.key === 'ArrowLeft') select(tabs[(i - 1 + tabs.length) % tabs.length]);
        });
      });
    });
  }


  /* ---------- Policy table of contents ---------- */
  function initToc() {
    var list = $('[data-toc]'), doc = $('[data-policy]'); if (!list || !doc) return;
    var hs = $$('h2[id]', doc).filter(function (h) { return !h.closest('.sd1-polnav'); });
    list.innerHTML = hs.map(function (h) { return '<li><a href="#' + h.id + '">' + esc(h.textContent.replace(/^\d+\.\s*/, '')) + '</a></li>'; }).join('');
    var box = $('[data-toc-box]'); if (box && window.innerWidth < 992) box.open = false;
  }

  function init() { initToc(); syncThemeBtn(); initCatalog(); initProduct(); initTabs(); refreshCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
